export const CAMPAIGN = {
  label: "Höstkampanj",
  percent: 10,
  start: new Date("2026-10-01T00:00:00+02:00"),
  end: new Date("2026-11-30T23:59:59+01:00"),
  periodText: "1 oktober – 30 november",
  shortText: "1 okt – 30 nov",
  code: "HÖST",
  categoryKeys: ["start", "kor", "intensiv", "start40", "kor40"],
  scopeText: "alla paket med körlektioner",
  terms: "Gäller alla paket som innehåller körlektioner (start-, kör- och intensivpaket) – ej Risk 1 & 2 Paketpris, riskettan/halkbana separat eller enskilda körlektioner. Endast privatpersoner. Gäller vid köp online med kort eller Qliro delbetalning – ej vid fakturaköp som faktureras direkt av oss (då gäller ordinarie pris). Kan ej kombineras med andra erbjudanden.",
};

const preview = () => typeof window !== "undefined" && new URLSearchParams(window.location.search).get("kampanj") === "1";

export const campaignAnnounced = () => preview() || new Date() <= CAMPAIGN.end;
export const campaignActive = () => preview() || (new Date() >= CAMPAIGN.start && new Date() <= CAMPAIGN.end);

export const toNumber = (priceStr) => parseInt(String(priceStr).replace(/\D/g, ""), 10);
export const formatKr = (n) => `${Math.round(n).toLocaleString("sv-SE")} kr`;
export const campaignPrice = (priceStr) => Math.round(toNumber(priceStr) * (1 - CAMPAIGN.percent / 100));

const previewLastWeek = () => typeof window !== "undefined" && new URLSearchParams(window.location.search).get("kampanj") === "sista";
export const daysLeft = () => (previewLastWeek() ? 3 : Math.max(0, Math.ceil((CAMPAIGN.end - new Date()) / 86400000)));
export const lastWeek = () => previewLastWeek() || (campaignActive() && daysLeft() <= 7);

export const campaignApplies = (categoryKey) => campaignActive() && CAMPAIGN.categoryKeys.includes(categoryKey);
